import Vue from 'vue'
import store from '../store'

Vue.directive('ui-permission', function (el, bind) {
  let value = bind.value
  let permission = _.get(store, 'state.userInfo.menu_list', [])
  if (permission.includes(value)) {
    return
  }
  Vue.nextTick(() => {
    el.style.display = 'none'
  })
})
